import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

import MuiTable from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import Typography from "@material-ui/core/Typography"
import MuiLink from "@material-ui/core/Link"

import { useAdminState } from "../Context"
import AdminLoader from "components/partials/AdminLoader"
import AdminEmptyMessage from "components/partials/AdminEmptyMessage"
import AdminTableContainer from "components/partials/AdminTableContainer"
import AdminActionContainer from "components/partials/AdminActionContainer"
import AdminNavigation from "components/partials/AdminNavigation"
import MultiSelectActions from "./MultiSelectActions"
import Row from "./Row"
import Header from "./Header"
import Pagination from "./Pagination"

import { useAppSelector } from "common/hooks"
import { Role } from "common/types"

const Table = () => {
    const { user: currentUser } = useAppSelector(state => state.auth)
    const currentUserRole = Role[currentUser.role]
    const disabled = currentUserRole < Role.Superadmin
    const showCompany = currentUserRole >= Role.Superadmin

    return (
        <>
            <AdminNavigation />

            <AdminTableContainer>
                <MuiTable>
                    <Header showCompany={showCompany} />
                    <TableBody>
                        <Rows showCompany={showCompany} />
                    </TableBody>
                </MuiTable>
            </AdminTableContainer>

            <AdminActionContainer>
                <Pagination />
                {!disabled && <MultiSelectActions />}
            </AdminActionContainer>
        </>
    )
}

const Rows = props => {
    const location = useLocation()
    const { rows, isLoading } = useAdminState()
    const { t } = useTranslation()

    if (isLoading) {
        return <AdminLoader colSpan={6} />
    }

    if (!rows.length) {
        return (
            <AdminEmptyMessage
                colSpan={6}
                title={t("view.adminCatalogs.modifyFilterTitle")}
            >
                <Typography>
                    {t("view.adminCatalogs.modifyFilterMessage1")}&nbsp;
                    <MuiLink to={location.pathname} component={Link}>
                        {t("view.adminCatalogs.modifyFilterMessage2")}
                    </MuiLink>
                    .
                </Typography>
            </AdminEmptyMessage>
        )
    }

    return (
        <>
            {rows.map(row => (
                <Row key={row.id} data={row} showCompany={props.showCompany} />
            ))}
        </>
    )
}

export default Table
